import { useState, useEffect } from "react";

export default function useIsDevice(minWidth, maxWidth) {
  const checkWidthInRange = () =>
    window.innerWidth >= minWidth && window.innerWidth <= maxWidth;

  const [isInRange, setIsInRange] = useState(checkWidthInRange());

  useEffect(() => {
    const handleResize = () => {
      setIsInRange(checkWidthInRange());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [minWidth, maxWidth]);

  return isInRange;
}
